/**
 * 定制金主题 — 颜色与设计令牌
 * 来源：Figma「收银台 (定制主题)」
 */
export default {
  // 主色（金橙）
  primary: '#E68F16',
  primaryLight: '#FDBA44',
  primaryBright: '#F5BB57',
  primaryDeep: '#DC7C02',
  primaryNavy: '#392812',
  primaryNavyDark: '#171716',
  primaryHighlight: '#F39A12',

  // 文字蓝字段保留为同结构别名
  textBlue: '#E68F16',
  textBlueLight: '#F5BB57',
  textBlueMuted: '#A39C96',

  // 按钮
  btnText: '#FFFFFF',
  btnTextAlt: '#FFFFFF',
  btnGradientStart: '#FDBA44',
  btnGradientEnd: '#DC7C02',
  btnStrongGradientStart: '#F5BB57',
  btnStrongGradientEnd: '#DE7F05',
  btnStrongGradientEnd2: '#DE7F05',
  btnAccentText: '#FFFFFF',

  // 复制 / 强调
  accentYellow: '#F5BB57',
  accentYellowDark: '#DE7F05',

  // 边框
  borderGold: '#F39A12',
  borderAccent: '#E68F16',
  borderGray: '#EBE1D1',
  borderLight: '#F5EDE1',
  borderLighter: '#FAF3E8',
  borderInput: '#EBE1D1',

  // 文字
  textPrimary: '#202126',
  textSecondary: '#323231',
  textMuted: '#51585E',
  textDisabled: '#C7C3BE',
  textBrownDark: '#202126',
  textBrown: '#6B4C21',
  textBrownLight: '#75726D',
  textBrownMuted: '#A39C96',
  textTitle: '#202126',
  textPlaceholder: '#E3D5BE',
  textGray: '#75726D',
  textDark: '#202126',

  // 状态色
  success: '#029B00',
  danger: '#C65461',
  dangerBg: '#FFF3F2',
  dangerBorder: '#FFF3F2',
  tipsRed: '#D63345',
  amountRed: '#E68F16',
  errorRed: '#C65461',

  // 背景
  bgPage: '#FFFFFF',
  bgPageNavy: '#171716',
  bgCard: '#FFFFFF',
  bgSecondary: '#FFF8EF',
  bgInput: '#FFFDF9',
  bgStripe: '#FFF3DF',
  bgOverlay: 'rgba(105, 53, 0, 0.07)',
  bgBadge: 'rgba(90, 90, 90, 0.1)',
  bgGlass: '#FEFEFF',

  // 头部区域
  headerText: '#FFFFFF',
  headerSubText: '#FFFFFF',
  headerMutedText: '#A39C96',

  // 其他
  white: '#FFFFFF',
  disabled: '#C7C3BE',
  smsBtn: '#E68F16',
  pendingDesc: '#A39C96',
  copyBtn: '#E68F16',
  tipsColor: '#C65461',
};
